// Counters for diagnostics
const apiCallCounts = new Map(); // successful attempts recorded

export const clearApiCallRecords = () => {
  apiCallCounts.clear();
};

export const logApiCallTotals = () => {
  const keys = new Set([...apiCallCounts.keys()]);
  const summary = {
    uniqueKeys: keys.size,
    totalCalls: 0,
    perKey: {},
  };

  for (const key of keys) {
    const calls = apiCallCounts.get(key) || 0;
    summary.perKey[key] = { calls };
    summary.totalCalls += calls;
  }
  return summary;
};

const makeCallKey = (config) => {
  const method = (config.method || 'GET').toUpperCase();
  const url = config.url || '';
  let params = '';
  let data = '';

  try {
    params = config.params ? JSON.stringify(config.params) : '';
  } catch (e) {
    params = '[unserializable_params]';
  }

  try {
    data = config.data ? JSON.stringify(config.data) : '';
  } catch (e) {
    data = '[unserializable_data]';
  }

  return `${method}|${url}|${params}|${data}`;
};

export function checkAndRecordApiCall(config) {
  const key = makeCallKey(config);
  const now = Date.now();

  apiCallCounts.set(key, (apiCallCounts.get(key) || 0) + 1);

  return { key, now };
}
